"use client";

import React from "react";
import { Briefcase, Globe, Handshake, Network, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "U.S. Market Entry & Expansion Strategy",
  icon: Globe,
  scopes: ["Organization Design", "Regulatory Compliance", "Local Partnership Development"]
}, {
  title: "Commercial Model & Go-to-Market Design",
  icon: Briefcase,
  scopes: ["Organizational Design", "Capability Building", "Performance Optimization"]
}, {
  title: "Brand & Portfolio Adaptation",
  icon: TrendingUp,
  scopes: ["Brand Positioning", "Revenue Modeling", "Performance & Incentives"]
}, {
  title: "Value Chain & Operational Readiness",
  icon: Network,
  scopes: ["Logistics Planning", "Vendor Management", "Cost Reduction Strategies"]
}, {
  title: "Organization & Growth Infrastructure",
  icon: Handshake,
  scopes: ["Concept Validation", "Go-to-Market Strategy", "Strategic Alliances"]
}];
export default function TheGrowthArchitecture() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-growth-architecture" className="bg-background py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IiMwMDAiLz4KPC9zdmc+')] mix-blend-multiply" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-20 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-foreground tracking-tight mb-6">Where We Create Value</h2>
          <p className="text-lg text-muted-foreground font-light leading-relaxed">Practical support for companies evaluating or pursuing growth in the U.S. market.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
          {servicesData.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} data-index={index} className={`transition-all duration-1000 ease-out delay-${index * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="group h-full bg-card border border-border/40 shadow-sm hover:shadow-xl transition-all duration-500 rounded-none overflow-hidden flex flex-col">
                  <CardHeader className="pb-4 pt-10 px-10 flex-grow">
                    <div className="mb-8 inline-flex items-center justify-center w-16 h-16 rounded-full bg-secondary/50 group-hover:bg-secondary transition-colors duration-500">
                      <Icon className="w-8 h-8 text-muted-foreground transition-transform duration-500 group-hover:scale-110" strokeWidth={1} />
                    </div>
                    <CardTitle className="text-xl font-serif font-medium text-foreground leading-snug">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="px-10 pb-10 pt-0">
                    <div className="w-8 h-[1px] bg-border mb-6 group-hover:w-full transition-all duration-700 ease-in-out" />
                    
                    <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-in-out">
                      <div className="overflow-hidden">
                        <div className="pt-2 pb-2">
                          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest mb-4">
                            Service Scope
                          </p>
                          <ul className="space-y-3">
                            {service.scopes.map((scope, scopeIndex) => <li key={scopeIndex} data-index={scopeIndex} className="text-sm text-foreground/80 flex items-start gap-3 font-light">
                                <span className="w-1.5 h-1.5 rounded-full bg-primary/40 mt-1.5 shrink-0" />
                                <span className="leading-relaxed">{scope}</span>
                              </li>)}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}